import React from 'react'
import PropTypes from 'prop-types'
import FormError from './FormError'

const FieldArrayInputField = ({ field, form, error, ...props }) => {
  return (
    <div className="mb-6">
      <input
        {...field}
        {...props}
        value={field.value || ''}
        className={`w-full py-4 px-6 text-lg rounded-lg bg-primary-lighter placeholder-black ${
          error ? 'border border-error' : 'border border-transparent'
        }`}
        aria-labelledby={field.id}
      />
      {error && <FormError error={error} />}
    </div>
  )
}

FieldArrayInputField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.string,
  }),
  errors: PropTypes.object,
  props: PropTypes.object,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
}

export default FieldArrayInputField
